<template>
  <div
    :class="$style.noPromotionRow"
    role="button"
    tabindex="0"
    :aria-label="t('toplisting.modal.noPromotion.title')"
    @click="selectNoPromotion"
    @keydown.enter.prevent="selectNoPromotion"
    @keydown.space.prevent="selectNoPromotion"
  >
    <div :class="$style.noPromotionHeader" @click.stop>
      <HgRadioButton
        :name="radioName"
        :modelValue="String(modelValue)"
        :inputValue="noPromotionValue"
        :label="t('toplisting.modal.noPromotion.title')"
        @update:modelValue="emit('update:modelValue', $event)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { TOPLISTING_PROMOTION_NONE } from '@/constants/toplistingPromotion';
import { HgRadioButton } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';

const noPromotionValue = TOPLISTING_PROMOTION_NONE;

withDefaults(
  defineProps<{
    modelValue: string;
    /** Radio group `name` for accessibility (must match promotion cards). */
    radioName?: string;
  }>(),
  {
    radioName: 'toplistingPromotionCards',
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const { t } = useI18n();

function selectNoPromotion(): void {
  emit('update:modelValue', noPromotionValue);
}
</script>

<style lang="scss" module>
@import '@/assets/variables';
@import '@/assets/mixins';

.noPromotionRow {
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid $color-seafoam-70;
    outline-offset: 2px;
  }
}

.noPromotionHeader {
  @include heading-4;

  label {
    @include body-3-bold;
  }

  & {
    padding-bottom: $space-50;
  }
}
</style>
